import React from 'react';
import NavBar from 'components/Navigation';
import styles from './NavOnScroll.scss';// to import local scss fle

const NavOnScroll = props => (
  <div className={styles.container} >
    <NavBar {...props} />
  </div>
);

export default NavOnScroll;



// WEBPACK FOOTER //
// ./src/components/NavOnScroll/NavOnScroll.js